import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getThemeByType } from 'utils/common';
import Enums from 'utils/EnumsManager';
import LayoutModule from '../component/searchLayoutModule';
import { fetchDefaultSearchLayout } from '../flow/action';

const { ObjectTypes } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;

class SearchLayout extends React.Component {
  componentDidMount() {
    const { fetchDefaultSearchLayout } = this.props;
    [Leads, Accounts, Opportunities].forEach(objectType => {
      fetchDefaultSearchLayout(objectType);
    });
  }

  render() {
    return (
      <div>
        {
          [Leads, Accounts, Opportunities].map(objectType => (
            <LayoutModule
              key={objectType}
              objectType={objectType}
              theme={getThemeByType(objectType)}
              panelTitle={<FormattedMessage id={`global.properNouns.${objectType}`} />}
            />
          ))
        }
      </div>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language
});

const mapDispatchToProps = {
  fetchDefaultSearchLayout,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchLayout);



// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/container/index.jsx